//TODO: lazy loading
const inTrack = {
  id: 'in',
  hello: 'hello intrack',
  brandName: 'intrack',
  brandname: 'intrack',
  BrandName: 'InTrack',
  BRANDNAME: 'INTRACK',
  docs: 'https://docs.intrack.ir',
  campaignApi: 'https://docs.intrack.ir/transactional-campaign-api',
  documents: 'https://intrack.ir/documents/',
  restApi:
    'https://docs.intrack.ir/docs/getting-start/rest-api/rest-api-getting-started',
  config: 'InTrackConfig()',
  SDK: 'https://docs.intrack.ir/docs/getting-start/android/android-getting-started#1installation',
  Initialization:
    'https://docs.intrack.ir/docs/getting-start/android/android-getting-started#2-initialization',
  //    webSdk
  webSdkStart: 'https://docs.intrack.ir/web-sdk#getting-started',
  flutterSdkEvent:
    'https://docs.intrack.ir/docs/getting-start/flutter/tracking-events#tracking-custom-events',
  webSdk: 'https://docs.intrack.ir/docs/getting-start/web/web-getting-started',
  webSdkNoti:
    'https://docs.intrack.ir/docs/getting-start/web/web-push-notification#initialization',
  webSdkEvent:
    'https://docs.intrack.ir/docs/getting-start/web/tracking-events#tracking-custom-events',
  webSdkLogin:
    'https://docs.intrack.ir/docs/getting-start/web/tracking-users#login',
  flutterSdk:
    'https://docs.intrack.ir/docs/getting-start/flutter/flutter-getting-started#1-installation',
  flutterSdkNoti:
    'https://docs.intrack.ir/docs/getting-start/flutter/push-messaging#for-android',
  flutterDependency:
    'https://docs.intrack.ir/docs/getting-start/flutter/flutter-getting-started#adding-dependency',
  flutterSdkLogin:
    'https://docs.intrack.ir/docs/getting-start/flutter/tracking-users#login',
  sw: 'https://static1.intrack.ir/api/web/download/sdk/sw.js',
  manifest: 'https://static1.intrack.ir/api/web/download/sdk/manifest.json',
  webSdkProfile:
    'https://docs.intrack.ir/docs/getting-start/web/tracking-users#profile-updates',
  // mobile-SDK
  mobileSdk:
    'https://docs.intrack.ir/docs/getting-start/react-native/react-native-getting-started#1-install-customfieldssitename-react-native-library',
  mobileSdkLogin:
    'https://docs.intrack.ir/docs/getting-start/react-native/tracking-users#login',
  profile:
    'https://docs.intrack.ir/docs/getting-start/react-native/tracking-users#profile-updates',
  flutterProfile:
    'https://docs.intrack.ir/docs/getting-start/flutter/tracking-users#profile-updates',
  addingDependency:
    'https://docs.intrack.ir/docs/getting-start/react-native/react-native-getting-started#2-initialization',
  mobileSdkNoti:
    'https://docs.intrack.ir/docs/getting-start/android/push-messaging/',
  mobileSdkEvent:
    'https://docs.intrack.ir/docs/getting-start/react-native/tracking-events#tracking-custom-events',
  // android
  androidSdkLogin:
    'https://docs.intrack.ir/docs/getting-start/android/tracking-users#login',
  androidProfile:
    'https://docs.intrack.ir/docs/getting-start/android/tracking-users#profile-updates',
  androidEvent:
    'https://docs.intrack.ir/docs/getting-start/android/tracking-events#tracking-custom-events',
  androidSdk:
    'https://docs.intrack.ir/docs/getting-start/android/android-getting-started',
  // ios
  iosSdkLogin:
    'https://docs.intrack.ir/docs/getting-start/iOS/tracking-users#login',
  iosProfile:
    'https://docs.intrack.ir/docs/getting-start/iOS/tracking-users#profile-updates',
  iosEvent:
    'https://docs.intrack.ir/docs/getting-start/iOS/tracking-events#tracking-custom-events',
  iosSdk: ' https://docs.intrack.ir/docs/getting-start/iOS/ios-getting-started',
  iosSdkNoti: 'https://docs.intrack.ir/docs/getting-start/iOS/push-messaging',
  iosInitialization:
    'https://docs.intrack.ir/docs/getting-start/iOS/ios-getting-started#2-initialize-the-sdk',
  iosAdding:
    'https://docs.intrack.ir/docs/getting-start/iOS/ios-getting-started#1installation',
  // webhook
  webhook: 'https://docs.intrack.ir/webhook',
  shortnerSampleUrl: 'https://www.intrack.ir/search/category-mobile-phone/',
  shortnerDomain: 'intk.ir',
  importSw: `if ('function' === typeof importScripts) {
	importScripts("https://static1.intrack.ir/api/web/download/sdk/inTrack-sw.js");
}\n`,
};

const Usermost = {
  id: 'um',
  hello: 'hello usermost',
  brandName: 'Intrack',
  brandname: 'Intrack',
  BrandName: 'Intrack',
  BRANDNAME: 'USERMOST',
  docs: 'https://docs.usermost.com',
  campaignApi: 'https://docs.usermost.com/transactional-campaign-api',
  documents: 'https://usermost.com/documents/',
  restApi: 'https://docs.usermost.com/rest-api',
  SDK: 'https://docs.usermost.com/android-sdk#adding-the-sdk-to-the-project',
  sw: 'https://static1.usermost.com/api/web/download/sdk/sw.js',
  manifest: 'https://static1.usermost.com/api/web/download/sdk/manifest.json',
  iosInitialization:
    'https://docs.intrack.ir/docs/getting-start/iOS/ios-getting-started#2-initialize-the-sdk',
  config: 'UsermostConfig()',
  // mobile-sdk
  addingDependency: 'https://docs.usermost.com/mobile-sdk#getting-started',
  flutterDependency: 'http://docs.usermost.com/flutter-sdk#adding-dependency',
  mobileSdkNoti:
    'https://docs.usermost.com/mobile-sdk#mobile-push-messages-and-notifications',
  mobileSdkEvent: 'https://docs.usermost.com/mobile-sdk#custom-events',
  profile: 'https://docs.usermost.com/mobile-sdk#profile-updates',
  mobileSdk: 'https://docs.usermost.com/',
  mobileSdkLogin: 'https://docs.intrack.ir/mobile-sdk#login-and-logout',
  // webSdk
  webSdk: 'https://docs.usermost.com/web-sdk',
  webSdkStart: 'https://docs.usermost.com/web-sdk#getting-started',
  flutterSdkEvent:
    'https://docs.intrack.ir/docs/getting-start/flutter/tracking-events#tracking-custom-events',
  webSdkLogin: 'https://docs.usermost.com/web-sdk#login-and-logout',
  webSdkNoti: 'https://docs.usermost.com/web-sdk#web-push-notifications',
  webSdkEvent:
    'https://docs.intrack.ir/docs/getting-start/web/tracking-events#tracking-custom-events',
  webSdkProfile: 'https://docs.usermost.com/web-sdk#profile-updates',
  // android
  androidSdkLogin: 'https://docs.usermost.com/android-sdk#login-and-logout',
  androidProfile: 'https://docs.usermost.com/android-sdk#profile-updates',
  androidEvent: 'https://docs.usermost.com/android-sdk#custom-events',
  androidSdk: 'https://docs.usermost.com/android-sdk',
  Initialization: 'https://docs.usermost.ir/android-sdk#initialization',
  // webhook
  webhook: 'https://docs.usermost.com/webhook',
  //shortner
  shortnerSampleUrl: 'https://www.usermost.com/search/category-mobile-phone/',
  shortnerDomain: 'usrmo.com',
  importSw: `importScripts("https://static1.usermost.com/api/web/download/sdk/usermost-sw.js");`,
};

// console.log(process.env.THEME);
export default process.env.THEME === 'Usermost' ? Usermost : inTrack;
